<template>
    <li v-if="appTour" @click="startTour" >
        <a class="dropdown-item fs-16 d-inline-flex align-items-center" role="button">
            <i class="fi fi-rr-direction-signal me-2 text-gray-700"></i>
            {{  trans('general.page.start_tour') }}
        </a>
    </li>
</template>
<script>

export default {
    name: "TourNav",
    data() {
        return {
            appTour: null
        }
    },
    methods: {
        setTour(data) {
            this.appTour = data;
        },
        startTour() {
            if(this.appTour) {
                this.appTour.startTour();
            }
        },
    },
}
</script>
